import React from "react";
import cn from "classnames";
import styles from "./Suggestion.module.sass";
import Icon from "../../../Icon";
import { pb } from "../../../../services/pocketbase";

const Suggestion = ({ className, contract }) => {
  const handleDownload = (e) => {
    e.stopPropagation();
    if (contract && contract.document) {
      const fileUrl = `${pb.baseUrl}/api/files/${contract.collectionId}/${contract.id}/${contract.document}`;
      window.open(fileUrl, '_blank');
    }
  };

  const companyName = contract.expand?.company_id?.name || 'Contrat';

  return (
    <div className={cn(styles.link, className)} onClick={handleDownload}>
      <div className={styles.icon}>
        <img src="/images/content/contract_logo.png" alt="Contrat" style={{ width: '40px', height: '40px' }} />
      </div>
      <div className={styles.details}>
        <div className={styles.title}>Contrat</div>
        <div className={styles.content}>{companyName}</div>
      </div>
      <div className={styles.arrow}>
        <Icon name="download" size="24" />
      </div>
    </div>
  );
};

export default Suggestion;
